export default "__VITE_ASSET__Cn8VrTV2__"